import { UserContext } from '~/app';
import { ProviderJobResponses } from '~/features/market/job-responses/provider-responses/ProviderJobResponses';
import { JobOpportunities as ProviderJobOpportunities } from '~/features/provider-hlx/job-opportunities/JobOpportunities';

/**
 * Role-aware wrapper for /hlx/job-opportunities.
 *
 * Providers see the provider opportunities feature (canonical pattern).
 * Employers see provider responses to their regular job listings.
 *
 * Role detection follows the existing pattern used in
 * `routing/ProtectedHLXRoute.tsx` and `routing/HlxListingsRoute.tsx`.
 */
export const JobOpportunitiesRoute = () => {
  const isProvider = UserContext.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_PROVIDER' })
  );

  if (isProvider) {
    return <ProviderJobOpportunities />;
  }

  return <ProviderJobResponses />;
};
